import React from "react";
import { connect } from 'react-redux';
import { Row, Col, InputGroup, InputGroupAddon, Button, FormGroup, ButtonGroup } from "shards-react";

import { specialtiesListActions, getCurrentSpecialtiesLists } from "../../core/specialties-lists";
import { locationsListActions, getCurrentLocationsLists } from "../../core/locations-lists";
import { provincesListActions, getCurrentProvincesLists } from "../../core/provinces-lists";

class SearchBarModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      especialidadId: 0,
      provinciaId: 0,
      localidadId: 0,
    }

    this.select_especialidad = React.createRef();
    this.select_provincia = React.createRef();
    this.select_localidad = React.createRef();

    this.loadData = this.loadData.bind(this);

    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleFilters = this.handleFilters.bind(this);
    this.handleCleanFilters = this.handleCleanFilters.bind(this);
  }

  componentWillMount() {
      const {  authenticated, user } = this.props
      if (authenticated && user.sessionId)
        this.loadData()
  }

  componentDidUpdate(oldProps,oldState){

    const { user,  authenticated} = this.props
    if ( authenticated &&  oldProps.user.sessionId !== user.sessionId ){
      this.loadData()
    }
  }

  loadData(){
    const { user, loadProvinces, loadSpecialties } = this.props
    this.handleFilters()
    loadProvinces( user.sessionId )
    loadSpecialties( user.sessionId )
  }

  loadLocations(){
    const { user, loadLocations } = this.props
    loadLocations( this.select_provincia.value , user.sessionId )
  }


  handleKeyPress(event) {
    if (event.which === 13 || event.keyCode === 13)
      this.props.onSearch(this.input.value);
  }

  handleClick() {
    this.props.onSearch(this.input.value);
  }

  handleFilters(e) {

    this.props.handleFilters({
      especialidadId: this.select_especialidad.value,
      provinciaId: this.select_provincia.value,
      localidadId: this.select_localidad.value,
    })
  }

  handleCleanFilters(e) {

    this.select_especialidad.value = 0;
    this.select_provincia.value = 0;
    this.select_localidad.value = 0;

    this.handleFilters(e);
  }

  handleChange (key, event) {

    const { [key]: _value } = this.state
    const value = (event.target.validity.valid) ? event.target.value : _value;

    if ( value !== _value ) {

      if ( key === 'provinciaId' )
        this.loadLocations()

      this.setState({
          [key]: value
      });
    }
  }

  render() {
    const { specialties, locations, provinces } = this.props

    const specialties_options = specialties ? specialties.items.map( (item, key) => <option key={key} value={item.id}>{item.descripcion}</option>) : null
    const locations_options = locations ? locations.items.map( (item, key) => <option key={key} value={item.id}>{item.nombre}</option>) : null
    const provinces_options = provinces ? provinces.items.map( (item, key) => <option key={key} value={item.id}>{item.nombre}</option>) : null

    return (
      <Row>
        <Col className="col-12 col-lg-9">
          <Row>
          <FormGroup className="col-lg-3 col-md-6">
            <select className="form-control custom-select form-control-sm custom-select-sm" ref={e => this.select_especialidad = e} onChange={this.handleChange.bind(this, 'especialidadId')}>
              <option value="0">Especialidad</option>
              {specialties_options}
            </select>
           </FormGroup>
           <FormGroup className="col-lg-3 col-md-6">
             <select className="form-control custom-select form-control-sm custom-select-sm" ref={e => this.select_provincia = e} onChange={this.handleChange.bind(this, 'provinciaId')}>
               <option value="0">Provincia</option>
               {provinces_options}
             </select>
           </FormGroup>
           <FormGroup className="col-lg-3 col-md-6">
            <select className="form-control custom-select form-control-sm custom-select-sm" ref={e => this.select_localidad = e}  onChange={this.handleChange.bind(this, 'localidadId')}>
              <option value="0">Localidad</option>
              {locations_options}
            </select>
           </FormGroup>
           <ButtonGroup size="sm" className="col-lg-3 col-md-6 d-table form-group">
             <Button onClick={ this.handleFilters.bind(this) } > Filtrar </Button>
             <Button onClick={ this.handleCleanFilters.bind(this) } outline theme="secondary" className="mx-auto"> Limpiar </Button>
           </ButtonGroup>
         </Row>
        </Col>
        <Col className="col-12 col-lg-3 col-md-6">
          <InputGroup className="mb-3">
            <input className="form-control" ref={ n => this.input = n } onKeyPress={(e)=>this.handleKeyPress(e)} type="text"  placeholder="Buscar"   />
            <InputGroupAddon type="append">
              <Button onClick={ this.handleClick }  ><i className="material-icons">search</i></Button>
            </InputGroupAddon>
          </InputGroup>
          </Col>
    </Row>
  ) }
}


//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  return {
    user: state.session.user,
    authenticated: state.session.authenticated,
    specialties: getCurrentSpecialtiesLists(state, props),
    provinces: getCurrentProvincesLists(state, props),
    locations: getCurrentLocationsLists(state, props),
  };
};

const mapDispatchToProps = {
  loadLocations : locationsListActions.loadLocations,
  loadSpecialties : specialtiesListActions.loadSpecialties,
  loadProvinces : provincesListActions.loadProvinces,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchBarModal);
